export default __webpack_public_path__ + "static/media/minusIcon.d6d92192.svg";